<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> تعریف کارتابل پرسنل </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <form class="row gx-0 gy-0 p-0 m-0" [formGroup]="mdl_Search">

        <div class="col-4 p-1" *ngIf="lstUser.length">

            <div class="w-100 h-100">

                    <custom-filter  
    
                        [strValue]="returnStrValue('iSystemUser',mdl_Search.get('iLog_SystemUser')?.value,lstUser,'strCombinate')"

                        [strComment]="'strCombinate'" 
                        
                        [stylesArray]="['padding-top: 10px']" 
                        
                        [str_Placeholder]="'نام کاربر را جستجو کنید'"

                        [lst_Main]="lstUser" 
                        
                        [lst_SearchKey]="['strCombinate']" 
                        
                        [isDisabled]="false"

                        (hideOptions)="submitValue($event)">

                    </custom-filter>

            </div>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto p-1">

            <div class="w-100 h-100">

                <button class="btn btn-primary w-100" (click)="getRequest()">

                    جستجو

                </button>

            </div>

        </div>

    </form>

    <!--  -->

    <div class="border border-2 mt-2 p-2">

        <div class="row gx-0 gy-0 p-0 m-0">

            <div class="col-9 p-1">

                <div class="w-100 h-100">

                    <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

                </div>

            </div>

            <div class="col-auto p-1">

                <div class="w-100 h-100">

                    <button class="btn btn-success" (click)="AddRemoveAll(false)"> انتخاب همه </button>

                </div>

            </div>

            <div class="col-auto p-1">

                <div class="w-100 h-100">

                    <button class="btn btn-danger" (click)="AddRemoveAll(true)"> حذف همه </button>

                </div>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 235px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead class="">

                    <tr class="">

                        <th class="text-center col-1"> # </th>

                        <th class="text-center col-1" > انتخاب </th>

                        <th class="text-center"> جهت اطلاع </th>

                        <th class="text-center"> موضوع درخواست  </th>

                    </tr>

                </thead>

                <tbody class="">

                    <tr class="col-12 text-center" *ngFor="let item of lst_Allocation; let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td class=""> 

                            <input type="checkbox" [checked]="isSelected(item)" #bSelected (change)="setCheckBox($event.target.checked,item)">
                            
                        </td> 

                        <td class=""> 

                            <input type="checkbox" [checked]="isSelected2(item)" (change)="setCheckBox2($event.target.checked,item)" [disabled]="!bSelected.checked">
                            
                        </td>                        

                        <th> {{ item.strComment | faNum }} </th>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>